export default class Headroom {
    constructor(o) {
        this.defaultOptions = {
            $headroom: $('.headroom'),
            $headroomSpacing: $('.headroom-spacing'),
            classes: {
                initial: 'headroom--headroom',
                pinned: 'headroom--fixed',
                unpinned: 'headroom--unfixed',
                top: 'headroom--top',
                notTop: 'headroom--not-top',
            },
        };

        this.options = $.extend({}, this.defaultOptions, o);

        const self = this,
            $win = $(window),
            options = this.options;

        require(['headroom.js/dist/headroom'], Headroom => {
            $win.on('resize', () => {
                if (options.$headroom.is('.headroom--fixed')) {
                    options.$headroom.css('margin-top', 0);
                }

                options.$headroomSpacing.css('padding-top', options.$headroom.outerHeight());

                // trigger an event so that other components can act accordingly
                $win.data('initiallyResized', true).trigger('headroom.resized');
            }).trigger('resize');

            self._instance = new Headroom(options.$headroom[0], {
                offset: options.$headroom.height(),
                tolerance: 20, // mostly used for touch-pads/-screens
                classes: options.classes,
                onTop() {
                    options.$headroom
                        .removeClass('headroom--fixed')
                        .css('margin-top', 0);

                    self._instance.offset = options.$headroom.height();

                    options.$headroomSpacing.css('padding-top', options.$headroom.outerHeight());
                },
                onPin() {
                    self._instance.offset = 0;

                    options.$headroomSpacing.css('padding-top', options.$headroom.outerHeight());
                },
                onUnpin() {
                    options.$headroom.css('margin-top', 0);
                },
            });

            self._instance.init();
        });
    }

    show() {
        this._instance.pin();
    }

    hide() {
        this._instance.unpin();
    }
}
